export default __webpack_public_path__ + "static/media/mobileLeadershipImage.e7bfbf2f.png";